import React from 'react';
import TableWrapper from '../../elements/TableWrapper';
import {
    Layout, message, Row, Col
} from 'antd';
import MiCompAPI from '../../../util/api';
import img from '../../../assets/img/At the office-pana 1.png';
import moment from "moment";
const { Content } = Layout;
class PlanChange extends React.Component {
    constructor(props) {
        super(props);
        this.columns = [{
            title: 'Request No',
            dataIndex: 'Request1',
            render: () => "1234"
        },
        {
            title: 'Request Type',
            dataIndex: 'Request2',
            render: () => "Plan Change"
        },
        {
            title: 'Date of Request',
            dataIndex: 'requestDate',
            render: (text, record) =>
                record["requestDate"] !== null && record["requestDate"] !== ""
                    ? moment(record["requestDate"]).format("MM/DD/YYYY")
                    : "",
        },
        {
            title: 'Status',
            dataIndex: 'isCompleted',
            render: (text) => text ? "Completed" : "Not Completed"
        },
        ];
        this.state = {
            inviteActive: false,
            request: [],
        }
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    componentDidMount() {
        this.GetRequestsbyId();
    }
    GetRequestsbyId() {
        this.api.invoke("GetRequestsbyId", "get", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    this.setState({
                        request: data.data,
                    });
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
            }
        });
    }
    render() {
        return (
            <Content>
                <div className="mi_main_div" style={{paddingTop:"43px",}}>
                    <div className="mi_box_sd">
                        <Row span={24}>
                            <Col span={18}>
                                <h4 className="mi_box_h4">Requests</h4>
                            </Col>
                            <Col span={6}>
                                <img alt="example" style={{ height: '182px', marginTop: '-80px' }} src={img} />
                            </Col>
                        </Row>
                    </div>
                    <div className="div_TB">
                    <TableWrapper rowKey="id" columns={this.columns} data={this.state.request ? this.state.request : []} title="All Requests" search={true} />
                </div>
                </div>
            </Content>
        );
    }
}
export default PlanChange;